import React, { useEffect, useState } from "react";
import OpenNotificationWithIcon from "../../../common/utils/OpenNotificationWithIcon";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { showNotification } from "./NofificationMessagesSlice";
function NofificationMessages() {
  const notification = useSelector((state) => state.NofificationMessages);
  const intl = useIntl();
  const dispatch = useDispatch();
  useEffect(() => {
    var a = notification;
    if (notification.show) {
      OpenNotificationWithIcon(notification.type, notification.messageId);
    }

    dispatch(showNotification({ show: false, messageId: "", type: "" }));
  }, [notification]);

  return <>{/* <p></p> */}</>;
}

export default NofificationMessages;
